/**
 * Build a FormData body from a plain object so Laravel sees it correctly:
 *   - booleans   -> "1" / "0"   (Laravel `boolean` rule rejects "true"/"false")
 *   - nested obj -> bracket notation `key[sub]=...`  (Laravel parses to array)
 *   - arrays     -> `key[]=...` repeated entries
 *   - File/Blob  -> appended as-is
 *   - null/undef -> skipped
 *   - empty str  -> skipped (so e.g. `image: ''` doesn't trip an 'image' validator)
 */
export function toFormData(obj, fd = new FormData(), prefix = '') {
  if (obj === null || obj === undefined) return fd;

  for (const [k, v] of Object.entries(obj)) {
    const key = prefix ? `${prefix}[${k}]` : k;
    appendValue(fd, key, v);
  }
  return fd;
}

function appendValue(fd, key, v) {
  if (v === null || v === undefined) return;
  if (typeof v === 'boolean') {
    fd.append(key, v ? '1' : '0');
    return;
  }
  if (v instanceof File || v instanceof Blob) {
    fd.append(key, v);
    return;
  }
  if (Array.isArray(v)) {
    if (v.length === 0) return;
    v.forEach((item, i) => appendValue(fd, `${key}[${i}]`, item));
    return;
  }
  if (typeof v === 'object') {
    // Recurse into nested object using bracket notation.
    for (const [subKey, subVal] of Object.entries(v)) {
      appendValue(fd, `${key}[${subKey}]`, subVal);
    }
    return;
  }
  if (v === '') return; // Skip empty strings — let `nullable` validators do their thing.
  fd.append(key, String(v));
}
